import React, { createContext } from 'react';

export const ThemeContext = createContext({} as Theme);

interface ThemeProviderProps {
  children: React.JSX.Element;
  theme: Theme;
}

export const ThemeProvider = ({children, theme}: ThemeProviderProps): React.JSX.Element=> (
  <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
);
